module.exports = __webpack_public_path__ + "static/img/WeChat.a83961c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/WeChat.png
// module id = 38UT
// module chunks = 41